import { FC, useCallback } from 'react';

import DriverLine from './driverLine';
import LineChart from './lineChart';

import { DriverData } from '../../types/common';

import DownloadIcon from '../Icons/DownloadIcon';

import './index.css';

interface DigitalTachographChartProps {
  mileage: Record<string, number>;
  speed: Record<string, number>;
  driverData: DriverData | DriverData[];
  isToday: boolean;
}

const DigitalTachographChart: FC<DigitalTachographChartProps> = ({ mileage, speed, driverData, isToday }) => {
  const handleDownloadBoth = useCallback(() => {
    const files = [
      { value: mileage, name: 'mileage.json' },
      { value: speed, name: 'speed.json' }
    ];

    for (const file of files) {
      try {
        const data = file.value;
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = file.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
      } catch (e) {
        alert(`${file.name} 下載失敗`);
      }
    }
  }, [mileage, speed]);

  return (
    <div className="digital-tachograph-chart">
      <div className="digital-tachograph-chart__download-icon" onClick={handleDownloadBoth}>
        <DownloadIcon size={24} color="#ccc" />
      </div>
      <LineChart speed={speed} type="speed" isToday={isToday} />
      <div className="digital-tachograph-chart__driver-info">
        <DriverLine data={driverData} isToday={isToday} />
      </div>
      <LineChart mileage={mileage} type="mileage" isToday={isToday} />
    </div>
  );
};

export default DigitalTachographChart;